import awardReducer from "./award";
import blogReducer from "./blog";
import companyReducer from "./company";
import { configureStore } from "@reduxjs/toolkit";
import countryReducer from "./country";
import customerReducer from "./customer";
import educationCategoryReducer from "./educationCategory";
import educationReducer from "./education";
import galleryReducer from "./gallery";
import lessonReducer from "./lesson";
import levelReducer from "./level";
import productCategoryReducer from "./productCategory";
import productReducer from "./product";
import questionReducer from "./question";
import roleReducer from "./role";
import securityReducer from "./security";
import storeReducer from "./store";
import userReducer from "./user";
import promotionReducer from "./promotion";
import taskReducer from "./task";
import receiptReducer from "./receipt";
import notificationReducer from "./notification";
import chatReducer from "./chat";

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    companyReducer: companyReducer,
    productCategoryReducer: productCategoryReducer,
    storeReducer: storeReducer,
    countryReducer: countryReducer,
    userReducer: userReducer,
    roleReducer: roleReducer,
    customerReducer: customerReducer,
    productReducer: productReducer,
    blogReducer: blogReducer,
    galleryReducer: galleryReducer,
    awardReducer: awardReducer,
    educationReducer: educationReducer,
    educationCategoryReducer: educationCategoryReducer,
    levelReducer: levelReducer,
    questionReducer: questionReducer,
    lessonReducer: lessonReducer,
    promotionReducer: promotionReducer,
    taskReducer: taskReducer,
    receiptReducer: receiptReducer,
    notificationReducer: notificationReducer,
    chatReducer: chatReducer,
  },
});

export default store;
